import React from 'react';

import PropTypes from 'prop-types';

import { Input } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';

import { BILL_OPTIONS } from './constants/bill-to-account-options';
import { CountryDropdown } from '../../../../../components/country-dropdown';

import style from '../inputs.module.less';

const { accountNumber, billingCountry, billingPostalCode } = BILL_OPTIONS;

const BillToAccountExtraInput = ({ id, option = '', value = '', updateInputValue = noop, updateBillToAccount = noop }) => {
  if (option === billingCountry) {
    return (
      <CountryDropdown
        dropdownMenuShouldHaveWidthOfButton
        id={id}
        onCountrySelected={(v) => updateBillToAccount(option, v)}
        selectedCountryCode={value}
        shouldShowDefaultMenuItem
        togglerClassName={style['bigly-dropdown']}
        variant='form'
      />
    );
  }

  return (
    <Input
      data-testid={option}
      id={id}
      onBlur={(v) => updateBillToAccount(option, v)}
      onChange={(v) => updateInputValue(option, v)}
      value={value}
    />
  );
};

BillToAccountExtraInput.propTypes = {
  id: PropTypes.string,
  option: PropTypes.oneOf([accountNumber, billingCountry, billingPostalCode]),
  value: PropTypes.string,
  updateInputValue: PropTypes.func,
  updateBillToAccount: PropTypes.func,
};

export default BillToAccountExtraInput;
